import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { closeAlert, preventCopy } from "./common"
import { isBrowser, isElectron, isIOS } from 'react-device-detect';

const startApp = async (props) => {
    if ("serviceWorker" in navigator) {
        if (isBrowser || isElectron) {
            const regURL = "./fcm/firebase-messaging-sw.js";
            navigator.serviceWorker.register(regURL, {
                updateViaCache: 'none'
            }).then(async (registration) => {
                // console.log("Registration successful: ", registration); 
            }).catch((e) => {
                let _emsg = "Service worker registration failed";
                if (navigator.notification) {
                    // navigator.notification.alert(
                    //     _emsg, 
                    //     closeAlert, 
                    //     'Error', 
                    //     'Close'
                    // );
                    // console.log(_emsg + ': \n', e);
                } else {
                    // console.log(_emsg + ': \n', e);
                }

                
            }).finally(() => {
                ReactDOM.render(<App device={props} />, document.getElementById('root'));
            });
        } else {
            ReactDOM.render(<App device={props}/>, document.getElementById('root'));
        }
    } else {
        ReactDOM.render(<App device={props}/>, document.getElementById('root'));
    }    
}

if (window.cordova) {
    document.addEventListener('deviceready', startApp(true), false);
    function onDeviceReady() {
        if (isIOS) {
            window.cordova.plugins.disableCopyPaste.start(function(){
                console.log('disableCopyPaste success');
            }, function(sError) {
                console.log('disableCopyPaste error'); 
            });
        }

        // console.log('\nonDeviceReady fired...');
        window.open = window.cordova.InAppBrowser.open;
    }
    navigator.splashscreen.hide();
} else {
    preventCopy();
    startApp(false)
};

serviceWorker.unregister();